import {Component, Input, forwardRef, HostListener, ElementRef} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {SistemaService} from '@servicios/Sistema.Service';
import {TranslateService} from '@ngx-translate/core';import { AlphaChannel } from 'ngx-color-picker/lib/helpers';
;

declare var $: any;
declare function Focus(id: string): any;

const noop = () => {
};

export const CUSTOM_COLORPICKER_CONTROL_VALUE_ACCESSOR: any =
{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ColorPickerComponent),
    multi: true
};


@Component(
    {
        selector: 'colorPicker',
        templateUrl: './ColorPicker.template.html',
        styleUrls: ['./ColorPicker.scss'],
        providers: [CUSTOM_COLORPICKER_CONTROL_VALUE_ACCESSOR]
    })

export class ColorPickerComponent implements ControlValueAccessor {
    public innerValue: any = "";

    private onTouchedCallback: () => void = noop;
    private onChangeCallback: (_: any) => void = noop;

    @Input() titulo: string = ""; // titulo del input
    @Input() margenControl: boolean = true; // indica si el control lleva un margen de 30px (se recomienda para que el control sea responsivo automáticamente)

    @Input() disabled: boolean = false; // control deshabilitado
    @Input() verError: boolean = true; // indica si el error esta habilitado para mostrarse
    @Input() errorActivo: boolean = false; // indica si el error esta habilitado para mostrarse
    @Input() mensajeError: string = ""; // mensaje que desplegará cuando haya un error
    @Input() verAlpha: AlphaChannel = "disabled"; // mensaje que desplegará cuando haya un error

    public id: number = 0;
    public colorAbierto: boolean = false;
    public touched: boolean = false;

    constructor(public sistemaService: SistemaService, public translate: TranslateService, private eRef: ElementRef) {
        this.mensajeError = this.translate.instant("DatoIncompeto");
        this.sistemaService.numeroControl++;
        this.id = this.sistemaService.numeroControl;
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
    }

    Focus() {
    }

    LimpiarValor() {
        this.valor = "";
    }

    CambioColorAbierto(open: boolean) {
        if (!open) {
            this.touched = true;
        }
    }

    // control ngModel
    get valor(): any {
        return this.innerValue;
    };

    //set accessor including call the onchange callback
    set valor(nuevoValor: any) {
        if (nuevoValor !== this.innerValue) {
            this.innerValue = nuevoValor;
            this.onChangeCallback(nuevoValor);
        }
    }

    writeValue(valor: any) {
        if (valor !== this.innerValue) {
            this.innerValue = valor;
        }
    }

    registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }

    //From ControlValueAccessor interface
    registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }
}
